/*LIBRARY MODULE*/
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

/*PERSONAL COMPONENT*/

/*REDUX FUNCTION*/
import {
  get_price_2025,
  calculate_price,
  ever_purchased_license,
} from "../../App/actions/paymentActions";
import { set_value_user } from "../../App/actions/authActions";
import history from "../../App/actions/history";

/*PICTURE ASSET*/

/*GENERAL*/
import PricingCard from "./PricingCard";
import Modal from "../common_modal/Modal";

/*Data*/
import dict from "../../Data/dict.json";
import { FiberManualRecord, InfoOutlined } from "@material-ui/icons";
import { Box, Typography } from "@mui/material";

/*NON IMPORT*/

const all_included_licenses = [
  "license_basic",
  "license_sini_ai",
  "license_sini_data",
];

class PaymentTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      personal: {
        price: 0,
        no_discount: 0,
        month: 1,
        licenses: ["license_basic"],
      },
      team: {
        price: 0,
        no_discount: 0,
        month: 1,
        collaborators: 2,
        licenses: all_included_licenses,
      },
      modal_banner_trial: false,
      is_first_open: true,
      is_ever_purchase: false,
    };
  }

  toggle_modal_banner_trial = () => {
    const { modal_banner_trial } = this.state;
    this.setState({
      modal_banner_trial: !modal_banner_trial,
    });
  };

  componentDidMount = async () => {
    const { set_package_selected } = this.props;
    const params = new URLSearchParams(window.location.search);
    const payment_type = params.get("payment_type"); // string, ex: "personal", "team", "enterprise"
    const collaborators = +params.get("collaborators") || 2; // number
    const month = +params.get("month") || 1; // number
    let license_key = params.get("license"); // boolean

    const { is_ever_purchased_license } =
      (await this.props.ever_purchased_license()) || {};

    if (payment_type === "personal") {
      const license_suggestion = "license_basic";
      if (
        !is_ever_purchased_license &&
        license_key !== license_suggestion &&
        payment_type === "personal"
      ) {
        license_key = license_suggestion;
      }

      set_package_selected(payment_type);
      let licenses = [];
      let is_done = false;
      if (all_included_licenses.includes(license_key)) {
        all_included_licenses.forEach((item) => {
          if (!is_done) {
            licenses.push(item);
            if (item === license_key) is_done = true;
          }
        });
      }
      this.setState({
        [payment_type]: {
          ...this.state?.[payment_type],
          licenses,
          month,
          is_ever_purchased_license,
        },
      });
    } else if (payment_type === "team") {
      set_package_selected(payment_type);
      this.setState({
        [payment_type]: {
          ...this.state?.[payment_type],
          month,
          collaborators,
          is_ever_purchased_license,
        },
      });
    }

    this.props.get_price_2025();
    this.calculate_price("personal");
    this.calculate_price("team");
  };

  componentDidUpdate = async (prevProps, prevState) => {
    const is_month_personal_diff =
      prevState?.personal?.month !== this.state?.personal?.month;
    const is_license_personal_diff =
      JSON.stringify(prevState?.personal?.licenses) !==
      JSON.stringify(this.state?.personal?.licenses);

    const is_month_team_diff =
      prevState?.team?.month !== this.state?.team?.month;
    const is_license_team_diff =
      JSON.stringify(prevState?.team?.licenses) !==
      JSON.stringify(this.state?.team?.licenses);
    const is_collaborators_team_diff =
      prevState?.team?.collaborators !== this.state?.team?.collaborators;

    if (
      is_month_personal_diff ||
      is_license_personal_diff ||
      is_month_team_diff ||
      is_license_team_diff ||
      is_collaborators_team_diff
    ) {
      this.calculate_price();
    }
  };

  toggleBuyNow = () => {
    const { set_page, package_selected, auth } = this.props;

    if (set_page && auth?.isAuthenticated) {
      set_page({
        package_object: {
          ...this.state?.[package_selected],
          package_type: package_selected,
        },
        new_page: "payment_method",
      });
    } else {
      this.props.set_value_user("modal_payment_universal", false);
      if (!window.location.search) {
        const params = new URLSearchParams();
        const { licenses, month, collaborators } =
          this.state?.[package_selected];
        const last_license = licenses?.at(-1);

        if (package_selected) params.set("payment_type", package_selected);
        if (licenses?.length > 0) params.set("license", last_license);
        if ([1, 12].includes(month)) params.set("month", month);
        if (collaborators >= 2 && collaborators <= 10)
          params.set("collaborators", collaborators);

        history.push(`/register?${params.toString()}`);
      } else {
        history.push(`/register${window.location.search}`);
      }
    }
  };

  calculate_price = async (package_name) => {
    const { is_first_open } = this.state;
    const { package_selected, auth } = this.props;
    let new_package_name = package_name || package_selected;
    const selected_package = this.state?.[new_package_name];
    const currency =
      (auth?.user?.country || "Indonesia") === "Indonesia" ? "IDR" : "USD";

    const res_calculation = await this.props.calculate_price({
      package_type: new_package_name,
      currency,
      license_includes: selected_package?.licenses?.map((license) => ({
        license_key: license,
        month: selected_package?.["month"],
      })),
      collaborators: selected_package?.collaborators,
    });

    this.setState({
      [new_package_name]: {
        ...this.state?.[new_package_name],
        price: res_calculation?.showed_price,
        no_discount: res_calculation?.showed_price_without_discount,
      },
      modal_banner_trial: is_first_open
        ? !res_calculation?.is_ever_purchased_license
        : false,
      is_ever_purchase: res_calculation?.is_ever_purchased_license,
      is_first_open: false,
    });
  };

  handleLicenseChecklist = (index) => {
    const current_licenses_length = this.state.personal?.licenses?.length;

    let new_index = +index;
    if (new_index + 1 <= current_licenses_length) {
      new_index = index - 1;
    }

    let lic = [];
    for (let idx = 0; idx <= new_index; idx++) {
      lic.push(all_included_licenses[idx]);
    }

    this.setState({
      personal: {
        ...this.state.personal,
        licenses: lic,
      },
    });
  };

  handle_duration = (package_type) => {
    const { month } = this.state?.[package_type] || {};
    const { is_ever_purchase } = this.state;
    const value = month === 12 ? 1 : 12;

    if (package_type === "personal" && !is_ever_purchase) {
      this.setState({
        [package_type]: {
          ...this.state?.[package_type],
          month: value,
          licenses: ["license_basic"],
        },
      });
    } else {
      this.setState({
        [package_type]: {
          ...this.state?.[package_type],
          month: value,
        },
      });
    }
  };

  handle_collaborators = (operator) => {
    const { collaborators } = this.state?.["team"] || {};

    let value = collaborators;
    if (operator === "+" && value < 10) {
      value = collaborators + 1;
    } else if (operator === "-" && value > 2) {
      value = collaborators - 1;
    }

    this.setState({
      team: {
        ...this.state?.["team"],
        collaborators: value,
      },
    });
  };

  render() {
    //local storage
    const language = localStorage?.language ? localStorage?.language : "ina";

    //local state
    const { personal, team, modal_banner_trial, is_ever_purchase } = this.state;

    //global props
    const { package_selected, set_package_selected, auth, trial_objects } =
      this.props;

    const currency =
      (auth?.user?.country || "Indonesia") === "Indonesia" ? "IDR" : "USD";

    let free_trial_text = "";
    if (!is_ever_purchase && personal?.month === 1) {
      free_trial_text = (
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // Vertically centers the items
            justifyContent: "start", // Horizontally centers the items
            height: "15px", // Example fixed height for the container
          }}
        >
          <Typography variant="body1" fontSize={12}>
            {dict["1 Month Free Access to SINI AI & SINI DATA"][language]}
          </Typography>
          <div
            className="tooltip"
            data-tooltip={dict["New Users Only"][language]}
          >
            <InfoOutlined
              style={{ marginLeft: "2px", fontSize: "16px", color: "black" }}
            />
          </div>
        </Box>
      );
    } else if (personal?.month === 12) {
      const style_box = {
        display: "flex",
        alignItems: "center", // Vertically centers the items
        justifyContent: "start", // Horizontally centers the items
        minHeight: "15px", // Example fixed height for the container
      };
      free_trial_text = (
        <div>
          <Box sx={style_box}>
            <FiberManualRecord
              style={{ marginRight: "5px", fontSize: "5px" }}
            />
            <Typography variant="body1" fontSize={12}>
              {dict["Annual plan – save 2 months of fees"][language]}
            </Typography>
            <div
              className="tooltip"
              data-tooltip={
                dict[
                  "With the annual plan, you pay for a full year upfront and save the equivalent of 2 months compared to monthly billing."
                ][language]
              }
            >
              <InfoOutlined
                style={{ marginLeft: "5px", fontSize: "16px", color: "black" }}
              />
            </div>
          </Box>

          {personal?.licenses?.length - 1 < 1 && !is_ever_purchase && (
            <Box sx={style_box}>
              <FiberManualRecord
                style={{ marginRight: "5px", fontSize: "5px" }}
              />
              <Typography variant="body1" fontSize={12}>
                {dict["1 Month Free Access to SINI AI & SINI DATA"][language]}
              </Typography>
              <div
                className="tooltip"
                data-tooltip={dict["New Users Only"][language]}
              >
                <InfoOutlined
                  style={{
                    marginLeft: "5px",
                    fontSize: "16px",
                    color: "black",
                  }}
                />
              </div>
            </Box>
          )}
        </div>
      );
    }

    //content
    const all_plans = [
      {
        package_type: "personal",
        title: "Personal",
        subtitle: dict["Best for personal use"][language],
        price: personal?.price,
        no_discount:
          personal?.price !== personal?.no_discount
            ? personal?.no_discount
            : null,
        free_trial: free_trial_text,
        unit: "Month",
        currency,
        settings: [
          {
            type: "slider",
            value: personal?.licenses?.length - 1,
            labels: [
              {
                value: 1,
                label: "SINI AI",
              },
              {
                value: 2,
                label: "SINI DATA",
              },
            ],
            onChange: this.handleLicenseChecklist,
          },
        ],
        included_licenses: personal?.licenses || [],
        duration: {
          header: dict["Duration"][language],
          month: personal?.month,
          onChange: this.handle_duration,
        },
        button: {
          text: dict["Choose"][language],
          onSubmit: this.toggleBuyNow,
        },
        is_active: package_selected === "personal",
      },
      {
        package_type: "team",
        subtitle: dict["Best for small company"][language],
        title: "Team",
        settings: [
          {
            header: dict["Collaboration"][language],
            type: "counter",
            value: team?.collaborators,
            unit: dict["collaborators"][language],
            onChange: this.handle_collaborators,
          },
        ],
        price: team?.price,
        no_discount:
          team?.price !== team?.no_discount ? team?.no_discount : null,
        unit: "User",
        currency,
        included_licenses: [
          "license_basic",
          "license_sini_ai",
          "license_sini_data",
        ],
        duration: {
          header: dict["Duration"][language],
          month: team?.month,
          onChange: this.handle_duration,
        },
        button: {
          text: dict["Choose"][language],
          onSubmit: this.toggleBuyNow,
        },
        is_active: package_selected === "team",
      },
      {
        package_type: "enterprise",
        title: "Enterprise",
        subtitle: dict["Contact us for tailored solution"][language],
        // extra_title: "",
        included_licenses: [
          "license_basic",
          "license_sini_ai",
          "license_sini_data",
        ],
        notes: {
          header: "Advanced Enterprise Features",
          body: dict["Every enterprise has unique needs and objectives."][
            language
          ],
          footer:
            dict[
              "We can tailor special features and plans specifically for you"
            ][language],
        },
        button: {
          text: dict["Contact us"][language],
          onSubmit: () => {
            const phone = "6281330881510";
            const url = `https://api.whatsapp.com/send?phone=${phone}`;
            window.open(url, "_blank");
          },
        },
        is_active: package_selected === "enterprise",
      },
    ];

    const prices_render = all_plans.map((plan, idx) => (
      <PricingCard
        key={idx}
        {...plan}
        set_package_selected={set_package_selected}
        is_ever_purchase={is_ever_purchase}
      />
    ));

    const modal_banner_trial_content = modal_banner_trial && (
      <Modal
        modalSize="small"
        id="modal_pricing"
        isOpen={modal_banner_trial}
        onClose={this.toggle_modal_banner_trial}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <p className="text_big margin_bottom text_center margin_bottom">
            {dict["You Get a First Purchase Bonus!"][language]}
          </p>

          <div className="sini_container_animation margin_bottom_extra">
            <div className="sini_shape_animation sini_circle_1"></div>
            <div className="sini_shape_animation sini_circle_2"></div>
            <div className="sini_shape_animation sini_circle_3"></div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "50px",
            }}
          >
            <div style={{ display: "flex", gap: "20px" }}>
              {trial_objects.map((trial, trial_idx) => (
                <div
                  key={trial_idx}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <label className="text_big">{trial?.name?.[language]}</label>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {trial?.subfeatures.map((feature, feature_idx) => (
                      <label className="text_medium" key={feature_idx}>
                        - {feature?.[language]}
                      </label>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            onClick={() => {
              set_package_selected("personal");
              this.setState(
                {
                  [package_selected]: {
                    ...this.state?.[package_selected],
                    month: 1,
                    licenses: ["license_basic"],
                  },
                },
                () => {
                  this.toggleBuyNow();
                }
              );
            }}
            className="button_big background_black text_white"
          >
            {dict["Claim Now!"][language]}
          </button>
        </div>
      </Modal>
    );

    return (
      <main>
        <div
          style={{
            width: "100%",
            overflowX: "auto",
          }}
        >
          <div className="adaptive_justify">
            <div
              style={{
                display: "flex",
                gap: "20px",
                minWidth: "max-content",
              }}
            >
              {prices_render}
            </div>
          </div>
        </div>
        {modal_banner_trial_content}
        {/* {modal_buy_now_content} */}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  payment: state.payment,
  license_reducer: state.license_reducer,
  trial_objects: state.payment?.license_features_2025?.filter((item) =>
    all_included_licenses.slice(1).includes(item.key)
  ),
});

export default withRouter(
  connect(mapStateToProps, {
    get_price_2025,
    calculate_price,
    set_value_user,
    ever_purchased_license,
  })(PaymentTable)
);
